module.exports = __webpack_public_path__ + "static/media/miws_on-blue_shinsotsu_132x76.8930ac54.jpg";